import { useState } from "react"
import useAppStore from "store/app"

const useSelect = (fieldName, validate) => {
  const { input_value, error_message } = useAppStore((state) => state.fields[fieldName])

  const updateFieldInputValue = useAppStore((state) => state.updateFieldInputValue)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)

  const [open, setOpen] = useState(false)

  const handleChange = (e) => {
    const { value } = e.target

    updateFieldInputValue(fieldName, value)
  }

  const handleClose = (e) => {
    const { value } = e.target

    const errorMessage = validate(value)

    updateFieldErrorMessage(fieldName, errorMessage)

    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return {
    handleChange,
    inputValue: input_value,
    errorMessage: error_message,
    handleOpen,
    handleClose,
    open,
  }
}

export default useSelect
